import React, { useState } from 'react'
import GiftCard from '../components/GiftsCard'
import Items from '../data/Storeitems.json'
import Mainlayout from '../layout/Mainlayout'

export default function ChooseGift() {
    const man = Items[0].man
    const woman = Items[0].woman
    const random = Items[0].random


    const mkit = () => { return (<GiftCard cata={man.kit} />) }
    const mshoes = () => { return (<GiftCard cata={man.shoes} />) }
    const mtracksuit = () => { return (<GiftCard cata={man.tracksuit} />) }
    const mtshirt = () => { return (<GiftCard cata={man.tshirt} />) }


    const womkit = () => { return (<GiftCard cata={woman.kit} />) }
    const womshoes = () => { return (<GiftCard cata={woman.shoes} />) }
    const womtracksuit = () => { return (<GiftCard cata={woman.tracksuit} />) }
    const womtshirt = () => { return (<GiftCard cata={woman.tshirt} />) }


    const ranBall = () => { return (<GiftCard cata={random.ball} />) }
    const ranSwim = () => { return (<GiftCard cata={random.swim} />) }
    const ranWater = () => { return (<GiftCard cata={random.water} />) }

    


    const [type, setType] = useState(1)


    const navigation = [
        { name: "پیاوان", num: 1 },
        { name: "ئافرەتان", num: 2 },
        { name: "هەمەجۆر", num: 3 },

    ]

    return (
        <Mainlayout>
            <div className='bg-dwam min-h-screen'>
                <div className=' bg-yakam w-full '>

                    <div className='flex flex-row' >
                        {navigation.reverse().map((nav) => {
                            return (
                                <>
                                    <div onClick={() => { setType(nav.num) }} className='w-1/3 p-3 h-full text-xs md:text-xl cursor-pointer item-center text-center hover:bg-seyam hover:text-yakam text-chwaram'><p className=''>{nav.name}</p></div>
                                </>
                            )
                        })}
                    </div>

                </div>

                <div>
                    {type === 1 ?
                        (
                            <>

                            {mkit()}
                            {mtracksuit()}
                            {mtshirt()}
                            {mshoes()}
                            </>
                        )
                        :
                        type === 2 ?
                            (
                                <>
                                    
                                {womkit()}
                                {womtracksuit()}
                                {womtshirt()}
                                {womshoes()}
                                </>
                            )
                            :
                            type === 3 ?
                                (
                                    <>
                                        
                                    {ranBall()}
                                    {ranSwim()}
                                    {ranWater()}
                                    </>
                                )
                                :
                                (
                                    null
                                )
                    }
                </div>
            </div>
        </Mainlayout>
    )
}
